import { Box } from "@chakra-ui/react"
import { Section, Text } from "@/components"
import { TeamsChannelsConfig } from "./TeamsChannelsConfig"

export const SettingsComponent = () => {
  return (
    <Section overflowY="auto" h="100vh">
      <Box maxW="720px">
        <Text fontSize="2xl" fontWeight="bold" mb={8}>Settings</Text>
        <TeamsChannelsConfig />
      </Box>
    </Section>
  )
}
